import React from "react";
import { Menu } from "lucide-react";

export default function Header2() {
  return (
    <div>
      <style>{`
        /* =========================
           MOBILE ONLY
        ========================== */

        .mobile-top-header,
        .mobile-auth-buttons {
          display: none;
        }

        @media (max-width: 768px) {

          /* HIDE ORIGINAL DESKTOP HEADER */
          .desktop-main-header {
            display: none !important;
          }

          /* MOBILE TOP HEADER */
          .mobile-top-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 14px;
         
            border-bottom: 1px solid rgba(209, 152, 109, 0.3);
          }

          .mobile-logo {
            width: 155px;
            height: auto;
            display: block;
          }

          .mobile-icons {
            display: flex;
            align-items: center;
            color: #d1986d;
          }

          /* MOBILE BUTTON SECTION */
          .mobile-auth-buttons {
            display: flex;
            gap: 10px;
            padding: 12px;
            background: transparent;
            border-bottom: 1px solid rgba(209, 152, 109, 0.3);
          }

          .mobile-auth-buttons a {
            flex: 1;
            text-align: center;
            text-decoration: none;
            padding: 10px 0;
            border-radius: 30px;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 0.3px;
          }

          .mobile-login-btn {
            background: transparent;
            color: #d1986d;
            border: 2px solid #d1986d;
          }

          .mobile-register-btn {
            background: #d1986d;
            color: #fff;
            border: 2px solid #d1986d;
          }
        }
      `}</style>

      {/* =========================
          DESKTOP HEADER
      ========================== */}

      <header
        className="desktop-main-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <a href="/">
          {/* Desktop Logo */}
          <img
            src="assets/images/img/logo.svg"
            className="desktop-logo img-fluid"
            alt="logo"
          />

          {/* Mobile Logo */}
          {/* <img
            src="assets/images/img/agn_dark_logo.svg"
            className="mobile-logo img-fluid"
            alt="logo"
          /> */}
        </a>

        <nav className="header-nav-middle">
          <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
            <div
              className="offcanvas offcanvas-collapse order-xl-2"
              id="primaryMenu"
            >
              <div className="offcanvas-header navbar-shadow">
                <h5 className="mb-0">Back</h5>

                <button
                  className="btn-close lead"
                  type="button"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
            </div>
          </div>
        </nav>

        <div style={{ display: "flex", gap: "5px" }}>
          <a
            data-cursor="pointer"
            href="https://app.agnadonai.com/live/auth/login"
            target="_blank"
            rel="noreferrer"
            className="btn btn-theme text-white"
            style={{
              backgroundColor: "#d1986d",
              borderColor: "#d1986d",
            }}
          >
            <span className="text-white">login</span>
          </a>

          <a
            data-cursor="pointer"
            href="https://app.agnadonai.com/auth/register"
            target="_blank"
            rel="noreferrer"
            className="btn btn-theme text-white"
            style={{
              backgroundColor: "#d1986d",
              borderColor: "#d1986d",
            }}
          >
            <span className="text-white">Register</span>
          </a>
        </div>
      </header>

      {/* =========================
          MOBILE HEADER
      ========================== */}

      {/* TOP */}
      <div className="mobile-top-header">
        <a href="/">
          <img
            src="assets/images/img/agn_dark_logo.svg"
            className="mobile-logo"
            alt="logo"
          />
        </a>

        <div className="mobile-icons">
          <Menu size={24} />
        </div>
      </div>

      {/* BUTTONS */}
      <div className="mobile-auth-buttons">
        <a
          href="https://app.agnadonai.com/live/auth/login"
          target="_blank"
          rel="noreferrer"
          className="mobile-login-btn"
        >
          LOGIN
        </a>

        <a
          href="https://app.agnadonai.com/auth/register"
          target="_blank"
          rel="noreferrer"
          className="mobile-register-btn"
        >
          REGISTER
        </a>
      </div>
    </div>
  );
}